module.exports = __webpack_public_path__ + "static/media/1009853.9d916e59.jpg";